module.exports = __webpack_public_path__ + "img/ax.c26f8374.svg";